import { useState, useContext } from 'react'

import { PassContext } from '../pass-context'

import PopupDialogText from './popup-editor-text'
import PopupDialogFields from './popup-editor-fields'
import PopupDialogBarcode from './popup-editor-barcode'
import PopupDialogModel from './popup-editor-model'
import PopupDialogStampImages from './popup-editor-stamp-images'
import PopupDialogImage from './popup-editor-image'

const editorTypes = {
  "meta.title": PopupDialogText,
  "meta.description": PopupDialogText,
  headerFields: PopupDialogFields,
  primaryFields: PopupDialogFields,
  secondaryFields: PopupDialogFields,
  auxiliaryFields: PopupDialogFields,
  backFields: PopupDialogFields,
  "meta.images.icon": PopupDialogImage,
  "meta.images.logo": PopupDialogImage,
  "meta.images.thumbnail": PopupDialogImage,
  "meta.images.strip": PopupDialogImage,
  "meta.images.stampcard": PopupDialogImage,
  "stamp-images": PopupDialogStampImages,
  "meta.images.background": PopupDialogImage,
  barcode: PopupDialogBarcode,
  organizationName: PopupDialogModel,
}

const ApplePopupEditor = ({ children, title, path, maxFields, colors, disabled, stampcardIndex, stampcardUrl, saveFunction, variable }) => {

  const { preview } = useContext(PassContext)

  const [editorOpen, setEditorOpen] = useState(false)

  const openPopup = event => {
    event.preventDefault()
    setEditorOpen(true)
  }

  const closePopup = () => {
    setEditorOpen(false)
  }

  const PopupEditorType = editorTypes[path]

  if (preview || disabled) return (<div className="preview">{children}</div>)

  return (
    <>
      <PopupEditorType open={editorOpen} close={closePopup} title={title} path={path} maxFields={maxFields} colors={colors} stampcardIndex={stampcardIndex} stampcardUrl={stampcardUrl} saveFunction={saveFunction} variable={variable} />
      <span onClick={openPopup}>{children}</span>
    </>
  )
}

export default ApplePopupEditor
